// A text field can be absent on an app-service wire in FOUR shapes — the key missing, an explicit
// `null`, the empty string, and whitespace only — and the blank ones really do arrive, because
// `clientes.nombre` is `default=''` NOT NULL. Collapsing all four leaves ONE representable absence
// per field, and that is what lets every consumer write `?? '—'` without re-deriving the question.
// Trimming is around the value, never inside it, so a phone keeps whatever grouping it arrived with.
//
// Written as an explicit ternary rather than `?.trim() || null`: the two say the same thing, but
// `||` reads as a bug to anyone who knows `??` (and the linter agrees), whereas naming the four
// shapes says that treating `''` as absent is the requirement, not an oversight.
export function blankToNull(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed === undefined || trimmed === '' ? null : trimmed;
}
